import React from 'react'

const HeartIcon = props => (
  <svg viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.0002 2.72135C5.1259 -4.39258 -3.94206 3.83016 1.8438 11.4776C5.2998 16.0443 9.02904 18.6058 10.8567 19.6867C11.5627 20.1044 12.4374 20.1044 13.1427 19.6867C14.9711 18.6058 18.6996 16.0443 22.1552 11.4776C27.9429 3.83016 18.875 -4.39184 12.0002 2.72135Z"
      fill="currentColor"
    />
  </svg>
)
export default HeartIcon
